(function () {
  var STORAGE_KEY = 'age-gate-lola-verified-until';

  document.querySelectorAll('[data-age-gate-lola]').forEach(function (gate) {
    var yesBtn = gate.querySelector('[data-age-gate-yes]');
    var noBtn = gate.querySelector('[data-age-gate-no]');
    var rememberDays = parseInt(gate.getAttribute('data-remember-days'), 10) || 30;
    var redirectUrl = gate.getAttribute('data-redirect-url') || 'https://www.google.com';

    function unlock() {
      var expiry = Date.now() + rememberDays * 24 * 60 * 60 * 1000;
      try {
        window.localStorage.setItem(STORAGE_KEY, String(expiry));
      } catch (e) {
        /* localStorage unavailable — the gate will simply reappear next
           visit, which is an acceptable fallback rather than blocking
           the confirmation itself. */
      }

      gate.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
    }

    if (yesBtn) {
      yesBtn.addEventListener('click', unlock);
    }

    if (noBtn) {
      // Sent to a neutral external destination rather than left stuck on
      // a dead end — the visitor is never trapped by this gate.
      noBtn.addEventListener('click', function () {
        window.location.href = redirectUrl;
      });
    }
  });
})();
